import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";
import * as moment from "moment";
import axios from "axios";

import { Payload } from "@neworbit/redux-helpers";
import { CaseConversationTaskModel } from "@teamprevent/common/messaging/models";

import { TaskModel, TasksAndCountModel } from "@teamprevent/common/task/taskActions/models";

import { ImmunisationTaskModel } from "../task/model";

import { ActionableTasksApi } from "./actionableTasksApi";
import * as actions from "./actionTypes";

export type ActionableTaskAction = ({ type: typeof actions.LOAD_ACTIONABLE_TASKS_SUCCESS } & Payload<TasksAndCountModel>) |
    ({ type: typeof actions.ASSIGN_USERS_SUCCESS } & Payload<{
        tasks: (TaskModel | ImmunisationTaskModel | CaseConversationTaskModel)[];
        users: { id: string; name: string }[];
    }>);

export const loadActionableTasksSuccess = (tasks: TaskModel[], totalCount: number): ActionableTaskAction => ({
    payload: {
        tasks,
        totalCount
    },
    type: actions.LOAD_ACTIONABLE_TASKS_SUCCESS
});

export const loadActionableTasks = (
    userIds: string[],
    teamIds: string[],
    customerIds: string[],
    taskCategories: string[],
    taskTypes: string[],
    dueDate: moment.Moment,
    includeWithoutDueDates: boolean,
    includeAssignedTasks: boolean) => {
    return async (dispatch: Dispatch) => {
        try {
            const [tasks, countResult] = await Promise.all([
                loadAndTrack(dispatch, actions.LOAD_ACTIONABLE_TASKS, ActionableTasksApi.getAll(
                    userIds, teamIds, customerIds, taskCategories, taskTypes, dueDate, includeWithoutDueDates, includeAssignedTasks)),
                loadAndTrack(dispatch, actions.LOAD_ACTIONABLE_TASKS_COUNT, ActionableTasksApi.getCount(
                    userIds, teamIds, customerIds, taskCategories, taskTypes, dueDate, includeWithoutDueDates, includeAssignedTasks))
            ]);
            dispatch(loadActionableTasksSuccess(tasks, countResult.totalCount));
        } catch (e) {
            if (axios.isCancel(e)) { return; } // eslint-disable-line import/no-named-as-default-member
            throw e;
        }
    };
};

export const assignUsersToActionableTasksSuccess = (
    payload: { tasks: (TaskModel | ImmunisationTaskModel | CaseConversationTaskModel)[]; users: { id: string; name: string }[] }
): ActionableTaskAction => ({
    type: actions.ASSIGN_USERS_SUCCESS,
    payload
});

export const assignUsersToActionableTasks = (
    tasks: (TaskModel | ImmunisationTaskModel | CaseConversationTaskModel)[],
    users: { id: string; name: string }[]
) => {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, actions.ASSIGN_USERS, ActionableTasksApi.assignUsersToActionableTasks(tasks, users));
        dispatch(assignUsersToActionableTasksSuccess({ tasks, users }));
    };
};
